var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { restClient } from '@cta-portal/webapp-common/lib/api/client';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import background from '@cta-portal/webapp-common/src/assets/images/backgrounds/background-texture.png';
import Loader from '@cta-portal/webapp-common/src/components/loader';
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { RoutePath, generateRoutePath } from '../../app/router/config';
import logoCta from '../../assets/images/logos/logo-cta-white.png';
import { UserContext } from '../../context/user';
export default function SignInJwt() {
    var t = useI18n().t;
    var navigate = useNavigate();
    var _a = useContext(UserContext), user = _a.user, reconnectUser = _a.reconnectUser, magic = _a.magicLinkContext.magic;
    var searchParams = useSearchParams()[0];
    var _b = useState(false), invalidPage = _b[0], setInvalidPage = _b[1];
    useEffect(function () {
        function signInJwt() {
            return __awaiter(this, void 0, void 0, function () {
                var jwt, profileId, nextUrl, response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            jwt = searchParams.get('jwt');
                            profileId = searchParams.get('profileId');
                            nextUrl = searchParams.get('next');
                            if (!jwt || jwt.length === 0) {
                                setInvalidPage(true);
                                return [2 /*return*/];
                            }
                            if (profileId && user && user.profileId === profileId) {
                                if (nextUrl) {
                                    window.location.href = decodeURIComponent(nextUrl);
                                }
                                else {
                                    navigate(generateRoutePath(RoutePath.ROOT, {}));
                                }
                                return [2 /*return*/];
                            }
                            if (!jwt) return [3 /*break*/, 4];
                            if (!magic) return [3 /*break*/, 2];
                            return [4 /*yield*/, magic.user.logout()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [4 /*yield*/, restClient.loginJwt({ email: 'cta', password: jwt })];
                        case 3:
                            response = _a.sent();
                            if (!response) {
                                setInvalidPage(true);
                                return [2 /*return*/];
                            }
                            _a.label = 4;
                        case 4:
                            if (!nextUrl) return [3 /*break*/, 5];
                            window.location.href = decodeURIComponent(nextUrl);
                            return [3 /*break*/, 7];
                        case 5: return [4 /*yield*/, reconnectUser()];
                        case 6:
                            _a.sent();
                            navigate(generateRoutePath(RoutePath.ROOT, {}));
                            _a.label = 7;
                        case 7: return [2 /*return*/];
                    }
                });
            });
        }
        signInJwt();
    }, []);
    return (_jsx(Container, { children: invalidPage ? (_jsxs(_Fragment, { children: [_jsx("a", { href: "/", children: _jsx("img", { alt: "logo-cta", src: logoCta }) }), _jsx("p", { children: t('sign-in-jwt.invalid-page') })] })) : (_jsx(Loader, {})) }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  background: url('", "');\n  background-attachment: fixed;\n  background-position: center;\n  background-size: 100% 100%;\n  display: flex;\n  height: 100vh;\n  flex-direction: column;\n  gap: 16px;\n  justify-content: center;\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: relative;\n  width: 100vw;\n\n  @media screen and (max-width: 824px) {\n    background: none;\n    padding-top: 64px;\n  }\n\n  & > a {\n    left: 24px;\n    position: absolute;\n    top: 24px;\n\n    & > img {\n      height: 72px;\n      width: auto;\n    }\n  }\n"], ["\n  align-items: center;\n  background: url('", "');\n  background-attachment: fixed;\n  background-position: center;\n  background-size: 100% 100%;\n  display: flex;\n  height: 100vh;\n  flex-direction: column;\n  gap: 16px;\n  justify-content: center;\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: relative;\n  width: 100vw;\n\n  @media screen and (max-width: 824px) {\n    background: none;\n    padding-top: 64px;\n  }\n\n  & > a {\n    left: 24px;\n    position: absolute;\n    top: 24px;\n\n    & > img {\n      height: 72px;\n      width: auto;\n    }\n  }\n"])), background);
var templateObject_1;
